export default function Section19() {
    return (
        <div className="w-full py-[60px] md:py-[60px] bg-[#f9f9f9] text-center SectionCTA">
            {/* Heading */}
            <h2 className="text-[28px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px] mb-4">
              Build Your Digital Presence with Mean3
            </h2>

            {/* Subheading */}
            <p className="text-[#555] text-[16px] md:text-[18px] mb-8 max-w-[650px] mx-auto">
                Mean3 is a trusted web development company , helping businesses create scalable and high-performing digital platforms. Our team provides tailored web app development services and expert development solutions designed to improve usability, performance, and online growth.  
            </p>
            <p className="text-[#555] text-[16px] md:text-[18px] mb-8 max-w-[650px] mx-auto">
               Whether you’re launching a new website or enhancing an existing platform, we focus on delivering reliable digital solutions that strengthen your online presence and support your Texas business’s long-term goals.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
                <a
                    href="https://mean3.com/contact-mean3"
                    className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                >
                    Get a Free Proposal
                </a>
                <a
                    href="https://mean3.com/contact-mean3"
                    className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                >
                    Book a Free Strategy Call
                </a>
            </div>




        </div>
    );
}
